import { Link, LinkProps } from "react-router-dom"
import { Flex, List, Typography } from "antd"

import { OptionallyVisible } from "@src/app/components/OptionallyVisible"
import css from "./index.module.css"

type Props = {
  actions?: JSX.Element
  isLoading?: boolean
  list: [string, any, LinkProps?][]
  style?: React.CSSProperties
}
export const TableExpandable = ({
  actions,
  isLoading = false,
  list,
  style,
}: Props) => {
  return (
    <div className={css.listWrapper} style={style}>
      <List
        dataSource={list}
        loading={isLoading}
        renderItem={([label, value, link]) => (
          <OptionallyVisible visible={Boolean(value)}>
            <List.Item className={css.listItem}>
              <Typography.Text className={css.listTitle}>
                {label}
              </Typography.Text>

              {link ? (
                <Link {...link} id="GENERATED_ID_TABLEEXPANDABLE_LINK_VOID_1">
                  <Typography.Link>{value}</Typography.Link>
                </Link>
              ) : (
                <Typography.Text>{value}</Typography.Text>
              )}
            </List.Item>
          </OptionallyVisible>
        )}
        style={{ width: "100%" }}
      />
      {actions && (
        <Flex justify="center" style={{ width: "100%" }}>
          {actions}
        </Flex>
      )}
    </div>
  )
}
